import type { FaireProductEntity } from "../../entity_types/product";

export const p_xbqk5txha6: FaireProductEntity = {
  token: "p_xbqk5txha6",
  type: "product",
  name: "Holiday Magic Santa Beaded And Embroidered Crossbody Handbag",
  brandToken: "b_bnd9vqh91x",
  brandName: "Mary Frances Accessories",
  imageUrl:
    "https://cdn.faire.com/fastly/0397807154f35523d4478cb2b8796d3ec4fb176c54b0d38a9c223e61b265405e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2503742651303ad484b8342bcd70713b86cfc83647f822ae572ea7c64d924280.jpeg",
    "https://cdn.faire.com/fastly/cf6266c52da101d299b0507207c4aa622552b8ff83944651ac3fb610c869d16a.jpeg",
    "https://cdn.faire.com/fastly/ee2975ab7358dcee8b3b2d64e21e826d50f84c59d5abfd45c00daa2c13946a92.jpeg",
    "https://cdn.faire.com/fastly/1691e98d1c70ebfdd2d583d85e25cac25ce066450fe377adba2934b10015661d.jpeg",
  ],
  priceDollars: 110,
  description:
    "Every Mary Frances piece is handmade!\n\nEmbrace the spirit of the season with Holiday Magic, a charming purse showcasing a vintage-inspired Santa surrounded by festive details. This elegant handbag brings a warm, nostalgic glow to your holiday style. A keepsake piece you'll love bringing out year after year.\n\nA NOTE ABOUT LEAD TIME: Orders ship \"as ready, up to 8 weeks\" — though most ship in just 4–5 weeks. The ship date shown when we accept your order is the latest possible date, not the actual ship date. Your order ships the moment your bags are ready. Questions? Just reach out — we're happy to help.",
  tags: [],
  msrpDollars: 275,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:27.303Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
